import { useIntl } from 'react-intl';

import { ZERO_DECIMAL_CURRENCIES } from 'common/utils/currencyDecimals';
import {
  ExperienceEntityType,
  NavigationAnnouncement,
  NavigationKey,
  useExperienceModuleContext,
} from 'modules/experience-core';

import { useGetOfferByMerchantID } from './useGetOfferByMerchantID';

export const useWoltCapitalNavigationAnnouncement = (): NavigationAnnouncement<'wolt-capital'>[] => {
  const { formatMessage, formatNumber } = useIntl();
  const {
    experienceEntity: { experienceEntityType, experienceEntityId },
  } = useExperienceModuleContext();

  const { hasOngoingOffer, merchantOfferCurrency, merchantOfferAmount, isLoadingMerchantsOffer } =
    useGetOfferByMerchantID(experienceEntityId, experienceEntityType === ExperienceEntityType.MERCHANT);

  const isDisabled = !(hasOngoingOffer && merchantOfferAmount && merchantOfferCurrency);

  if (isLoadingMerchantsOffer || isDisabled) {
    return [];
  }

  const formattedAmount = formatNumber(merchantOfferAmount, {
    style: 'currency',
    currency: merchantOfferCurrency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: ZERO_DECIMAL_CURRENCIES.includes(merchantOfferCurrency as Currency) ? 0 : 2,
  });

  return [
    {
      id: 'wolt-capital',
      navigationKey: NavigationKey.WOLT_CAPITAL,
      text: formatMessage({ id: 'wolt-capital.popover.text' }, { offerAmount: formattedAmount }),
    },
  ];
};
